<p-dialog header="Firmar asistencia" [modal]="true" 
[draggable]="false" 
[resizable]="false"
styleClass="p-dialog-firma-custom" 
[(visible)]="displayModalPresente" 
(onHide)="closeModalPresentismo()" 
[style]="{width: '500px'}">
    <p>
        Hoy {{ fecha }} a las {{ hora }} se registra la asistencia de:    
    </p>
    <p>
        Trabajador: <strong>{{ nombreTrabajador }}</strong>
    </p>
    <p>
        Estudio: <strong>{{ nombreEstudio }}</strong>
    </p>
    <p>
        Los resultados del estudio serán auditados por Provincia ART y comunicados
        al trabajador por ventanilla.
    </p>
    <p-footer>
        <p-button (click)="closeModalPresentismo()">Cancelar</p-button>
        <p-button (click)="showModalFirma()" id="clean-button">Firmar</p-button>
    </p-footer>
</p-dialog>

<section id="modal-firma">
    <app-topaz 
    (datosFirma)="recibirDatosFirma($event)" 
    [displayModalFirma]="displayModalFirma" 
    (closeModal)="closeModalFirma()"
    nombreTrabajador="{{nombreTrabajador}}"
    nombreEstudio="{{nombreEstudio}}"></app-topaz>  
</section>